import { EntityState } from '@ngrx/entity';
import { IQueue } from './iqueue';

export interface IQueueState extends EntityState<IQueue> {
    // additional entities state properties
    isExecuting: boolean;
    error: any;
    
}
